const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/user-management/invites/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import i18n from '@/lib/translations/i18n';
const filterBySchema = z.object({
  filterByRole: z.array(z.enum(['admin', 'member', 'orchestrator', 'visualizer'])).default([]),
  query: z.string().default('')
});
export const Route = createFileRoute('/(app)/org/$org/settings/user-management/invites/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(filterBySchema),
  loader: (): LoaderData => ({
    crumb: i18n.t($ => $.userManagement.title)
  }),
  staticData: {
    topNav: {
      title: i18n.t($ => $.userManagement.title)
    }
  }
});